import React, { useState } from "react";
import { useParams } from "react-router-dom";

import firebase from "firebaseFactory";
import { useLiveData } from "hooks";
import { HighchartsGrid } from "components/highcharts/HighchartsGrid";
import {
  getHighchartOptionsFromRealtimeData,
  DevicePackDataPoint,
} from "components/highcharts/HighchartOptionsFromRealtimeData";
import { useEventData, extractPlotlinesFromEventData } from "modules/events";
import { GroupedToggleList } from "components/GroupedToggleList";
import { PauseButton } from "components/PauseButton";

import { Page } from "../layout/Page";

import { GridListToggle } from "./components/GridListToggle";
import { packDataFields } from "./components/AvailableDataFields";

export const RealtimeDataPage = ({ getNow = Date.now }) => {
  const { siteId, unitId } = useParams();
  const [viewAsGrid, setViewAsGrid] = useState(true);
  const [currentDataFields, setCurrentDataFields] = useState<string[]>([
    "grid_current_a",
    "grid_voltage_v",
  ]);
  const [deviceData, setDeviceData] = useState<DevicePackDataPoint[]>([]);
  const { eventData } = useEventData(siteId, unitId, undefined, 20);
  const [isPaused, setIsPaused] = useState<boolean>(false);

  const filteredEventData =
    deviceData.length === 0
      ? []
      : eventData.filter((x) => x.timestamp_utc >= deviceData[0].timestamp_utc);
  const plotLines = extractPlotlinesFromEventData(filteredEventData);

  // TODO: Change this to sub to just unit pack data from firebase
  const filteredDeviceData = unitId
    ? deviceData.filter((x) => x.unit_id === unitId)
    : deviceData;

  const highchartOptions = getHighchartOptionsFromRealtimeData(
    currentDataFields,
    filteredDeviceData,
    plotLines,
    getNow
  );

  useLiveData(
    {
      isPaused: isPaused,
      maxDataPoints: 750,
      firebaseShard: firebase.shards.Customer,
      firebaseRef: `devices/dataBySite/${siteId}/historyCombined/data/pack_data`,
      orderByDescending: false,
      onInitialData: setDeviceData,
      onIncrementalData: setDeviceData,
    },
    [siteId]
  );
  return (
    <Page
      titleButtons={
        <>
          <PauseButton
            isPaused={isPaused}
            onClick={() => setIsPaused((state) => !state)}
          />
        </>
      }
    >
      <div className="bg-white p-4 rounded">
        <div className="flex flex-wrap w-full mb-6">
          <GroupedToggleList
            toggleGroups={packDataFields}
            selectedToggles={currentDataFields}
            onChange={setCurrentDataFields}
          />
        </div>
      </div>
      <div className="py-6 inline-flex justify-end w-full">
        <GridListToggle viewAsGrid={viewAsGrid} onChange={setViewAsGrid} />
      </div>
      <HighchartsGrid options={highchartOptions} viewAsGrid={viewAsGrid} />
    </Page>
  );
};
